<div class="{{containerClassList}} no-content ">
  <div class=" content-item mx-auto" style="--order:2">
    <div (click)="onClickNoContent.emit(slug)" class="{{innerClassList}} text-muted cursor-pointer text-center bg-hover-faded-gradienttt
            {{class}}  border-on-hover rounded-slight hover-bg-gradient-faded ">
      <div class="icon-holder bounce" style="--order:8">
        <mat-icon *ngIf="(icon | iconType) === 'SVG'"
                  [svgIcon]="icon" class="icon-large"></mat-icon>
        <mat-icon *ngIf="(icon | iconType) === 'MATERIAL'"
                  class="icon-large">{{icon}}</mat-icon>
      </div>
      <div class="{{titleClassList}}"> {{ title }}</div>
    </div>
  </div>
</div>

